module.exports = __webpack_public_path__ + "img/impostor-bg-2.3ca1ea0d.webp";